import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Trash2, MailOpen, Mail } from "lucide-react";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  const load = () => api.get("/admin/messages").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/admin/messages/${id}/read`);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/messages/${id}`);
    toast.success("Silindi");
    if (active?.id === id) setActive(null);
    load();
  };

  return (
    <div data-testid="admin-messages-page" className="p-10">
      <div className="overline text-[#4A6A8F]">Gelen kutusu</div>
      <h1 className="font-serif-ap text-4xl text-[#0F2746] mt-3">İletişim Mesajları</h1>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 min-h-[60vh]">
        <div className="lg:col-span-5 bg-white border border-[#0F2746]/10 overflow-hidden">
          {items.length === 0 && <div className="p-8 text-sm text-[#3A5170]">Henüz mesaj yok.</div>}
          {items.map((m) => (
            <button
              key={m.id}
              data-testid={`message-row-${m.id}`}
              onClick={() => { setActive(m); if (!m.is_read) markRead(m.id); }}
              className={`w-full text-left p-5 border-b border-[#0F2746]/10 hover:bg-[#0F2746]/5 transition-colors ${active?.id === m.id ? "bg-[#0F2746]/5" : ""}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    {m.is_read ? <MailOpen size={14} className="text-[#4A6A8F]" /> : <Mail size={14} className="text-[#C4A47C]" />}
                    <span className={`font-serif-ap text-lg ${m.is_read ? "text-[#3A5170]" : "text-[#0F2746]"}`}>{m.name}</span>
                  </div>
                  <div className="text-xs text-[#3A5170] mt-1 truncate">{m.subject || m.message.slice(0, 60)}</div>
                </div>
                <div className="text-[10px] text-[#4A6A8F] shrink-0">{new Date(m.created_at).toLocaleDateString()}</div>
              </div>
            </button>
          ))}
        </div>

        <div className="lg:col-span-7 bg-white border border-[#0F2746]/10 p-8">
          {active ? (
            <div data-testid="message-detail">
              <div className="flex justify-between items-start">
                <div>
                  <div className="overline text-[#4A6A8F]">{new Date(active.created_at).toLocaleString()}</div>
                  <h2 className="font-serif-ap text-3xl text-[#0F2746] mt-2">{active.subject || "(Konu yok)"}</h2>
                </div>
                <button
                  data-testid={`delete-message-${active.id}`}
                  onClick={() => remove(active.id)}
                  className="text-[#0F2746] hover:text-red-600 p-2"
                ><Trash2 size={16} /></button>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
                <div><div className="overline text-[10px] text-[#4A6A8F] mb-1">İsim</div><div className="text-[#0F2746]">{active.name}</div></div>
                <div><div className="overline text-[10px] text-[#4A6A8F] mb-1">E-posta</div><a href={`mailto:${active.email}`} className="text-[#0F2746] ap-link-underline">{active.email}</a></div>
                {active.phone && <div><div className="overline text-[10px] text-[#4A6A8F] mb-1">Telefon</div><div className="text-[#0F2746]">{active.phone}</div></div>}
              </div>
              <div className="mt-8 pt-8 border-t border-[#0F2746]/10">
                <div className="overline text-[10px] text-[#4A6A8F] mb-3">Mesaj</div>
                <p className="text-[#0F2746] leading-relaxed whitespace-pre-line">{active.message}</p>
              </div>
            </div>
          ) : (
            <div className="text-sm text-[#3A5170]">Görüntülemek için bir mesaj seçin.</div>
          )}
        </div>
      </div>
    </div>
  );
}
